import React from 'react';
import { getDefaultPagingNumberOfItems } from '../../helpers/PackageJsonHelper';
import { newSearchCustomers, searchCustomersSalesforce } from '../../networking/Networking';
import { getStyle } from '../../styles/styles';
import NewEditableGrid from '../shared/NewEditableGrid';

export default class SelectCustomer extends React.Component {
    state = {
        searchTerm: '',
        pages: 1,
        totalPages: 0,
        customerList: [],
        customerListTotal: [],
        newSearch: false,
        filter: false,
        columnDetail: null,
        itemsPerPage : getDefaultPagingNumberOfItems()
    }

    componentDidMount() {
        if(this.props.customerListTotal){
        const totalCount = this.props.customerListTotal.length;
            const totalPages = Math.ceil(totalCount / this.state.itemsPerPage);
            let _columnDetail = null;
            if (this.props.customerColumns != null) {
                _columnDetail = JSON.parse(this.props.customerColumns );
            }
            this.setState({
                totalPages,
                newSearch: true,
                filter: true,
                customerList: this.props.customerListTotal,
                customerListTotal: this.props.customerListTotal,
                columnDetail: _columnDetail
            });
        }
    }

    handleUpdateSearchTerm = (event) => {

        this.setState({ searchTerm: event.target.value });
        let customers = [...this.props.customerListTotal];
        customers = customers.filter(c => c["Customer Name"].toLowerCase().includes(event.target.value));

        const totalCount = customers.totalCount;
        const totalPages = Math.ceil(totalCount / this.state.itemsPerPage);

            this.setState({
                totalPages,
                newSearch: true,
                filter: true,
                customerList: customers,
            });
    }

    changePage = (value) => {
        this.setState({ pages: value });
    }

    handleSearchClick = async (event) => {
        if (event != null) {
            event.preventDefault();
        }
        await this.loadCustomers();
    }

    handleRecordClick = (objCustomer) => {
        this.props.onCustomerSelected(objCustomer, 2);
    }

    getAllCustomers = async () => {
        const value = await newSearchCustomers('', 0, 0);
        if (value.customers !== undefined) {
            return value.customers;
        } else {
            return [];
        }
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchClick();
        }
    };

    render() {
        return (
            <div>
                <form className="uk-grid">
                    <div className="uk-width-1-2">
                        <div className="uk-margin" style={{ ...getStyle().inputStyle, marginTop: '5px' }}>
                            <input
                                className="uk-input"
                                id="searchTerm"
                                type="text"
                                value={this.state.searchTerm}
                                onChange={this.handleUpdateSearchTerm}
                                onKeyPress={this.handleKeyPress}
                                autoFocus={true} />
                        </div>
                    </div>
                </form>
                <NewEditableGrid
                    data={this.state.customerList}
                    columnDetails={this.state.columnDetail}
                    enableClick={true}
                    clickFunction={this.handleRecordClick}
                    newSearch={this.state.newSearch}
                    useDeleteButton={false}
                    hiddenHeaders={['FeeStructureID', 'WireFeeSide', 'RelatedWireFeeID', 'DefaultBuyCurrencyID', 'DefaultSellCurrencyID']}
                    usePaginator={true}
                    changePage={this.changePage}
                    numberOfPages={this.state.totalPages}
                    pageNumber={this.state.pages}
                    numberPerPage={getDefaultPagingNumberOfItems()}
                    enableSortByHeader={true}
                    useFilter={this.state.filter}
                    filterFunction={this.getAllCustomers}
                />
            </div>
        )
    }
}